function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import entityComposition from '../../common/classes/entityComposition';
import SegmentedPicker from '../../common/controls/segmentedPicker';
import SinglePicker from '../../common/controls/singlePicker';
import useLookup from '../../../utils/useLookup';
const ContractSpecPhaseCodePicker = ({
  options,
  value: _value = null,
  onChange
}) => /*#__PURE__*/React.createElement(SinglePicker, {
  label: useLookup('Phase Code'),
  options: options,
  value: _value,
  returnValueKey: "id",
  placeholder: "Select...",
  onChange: onChange
});
ContractSpecPhaseCodePicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
class ContractSpecGeneral extends Component {
  constructor(props) {
    super(props);
    this.getPhaseCodes = this.getPhaseCodes.bind(this);
    this.handleChangeActive = this.handleChangeActive.bind(this);
    this.handleJobChange = this.handleJobChange.bind(this);
    this.handleChangeJobPhaseCodeID = this.handleChangeJobPhaseCodeID.bind(this);
    this.state = {
      originalActive: {}
    };
  }
  componentDidMount() {
    const {
      active
    } = this.props;
    if (active.jobID) {
      this.getPhaseCodes(this.props);
    }
  }

  /**
   *  If the contract spec record doesn't load before the component finishes mounting, run the
   *  phase code query once props.active is available. Also, re-run the query on every job change.
   */
  componentDidUpdate(prevProps) {
    const {
      active
    } = this.props;
    if (active.jobID && active.jobID !== prevProps.active.jobID) {
      this.getPhaseCodes(prevProps);
    }
  }

  /**
   *  Get the set of available phase codes
   */
  getPhaseCodes() {
    const {
      active,
      jobPhaseCodeWithStatus,
      jobPhaseCodeWithStatusActions
    } = this.props;
    const {
      originalActive
    } = this.state;
    // @TODO https://www.pivotaltracker.com/story/show/157495726.
    // this is horribly confusing. The server query expects the jobPhaseCodeID to be
    // passed, but if the user selects another job jobPhaseCodeID is cleared. If the user then goes
    // back to the original job, the original option will be missing unless it's stored in state.
    // This is a good candidate for rework.
    let jpcID = active.jobPhaseCodeID;
    if (!jpcID && active.jobID === originalActive.jobID) {
      jpcID = originalActive.jobPhaseCodeID;
    }

    // modifying indexQuery is generally discouraged, favoring usage of serverFilter. The server
    // endpoint does not yet support this: https://www.pivotaltracker.com/story/show/157495726.
    const jobPhaseCodeQuery = _objectSpread(_objectSpread({}, jobPhaseCodeWithStatus.indexQuery), {}, {
      jobID: active.jobID,
      active: active.active,
      jpcID
    });
    jobPhaseCodeWithStatusActions.serverIndex(jobPhaseCodeQuery);
    if (!originalActive.jobID) {
      this.setState({
        originalActive: active
      });
    }
  }
  handleChangeActive(value) {
    const {
      onChange
    } = this.props;
    onChange('active', value);
  }
  handleJobChange(newJob) {
    const {
      onChange
    } = this.props;
    onChange('jobID', newJob);
    // delete existing jobPhaseCodeID when a new jobID is selected to avoid improper jobPhaseCodeID
    onChange('jobPhaseCodeID', null);
  }
  handleChangeJobPhaseCodeID(value) {
    const {
      onChange
    } = this.props;
    onChange('jobPhaseCodeID', value);
  }
  render() {
    const {
      jobSelectContractSpec,
      jobSelectContractSpecActions,
      active,
      jobPhaseCodeWithStatus
    } = this.props;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "General"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Job Number",
      entity: jobSelectContractSpec,
      entityActions: jobSelectContractSpecActions,
      includeSelectionsForID: active.id,
      value: active.jobID,
      labelKey: "jobNumber",
      returnValueKey: "id",
      placeholder: "Required...",
      onChange: this.handleJobChange
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      names: ['Active', 'Inactive'],
      allowNull: false,
      values: [1, 0],
      label: "Spec Status",
      onChange: this.handleChangeActive,
      value: active.active
    }))), /*#__PURE__*/React.createElement(ContractSpecPhaseCodePicker, {
      options: jobPhaseCodeWithStatus.list,
      value: active.jobPhaseCodeID,
      returnValueKey: "id",
      placeholder: "Select...",
      onChange: this.handleChangeJobPhaseCodeID
    }));
  }
}
ContractSpecGeneral.defaultProps = {
  active: {}
};
ContractSpecGeneral.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    jobID: PropTypes.string,
    active: PropTypes.number,
    jpcID: PropTypes.string,
    jobPhaseCodeID: PropTypes.string
  }),
  jobPhaseCodeWithStatus: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobPhaseCodeWithStatusActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobSelectContractSpec: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobSelectContractSpecActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export { ContractSpecGeneral as TestContractSpecGeneral };
export default entityComposition(ContractSpecGeneral, ['jobSelectContractSpec', 'jobPhaseCodeWithStatus'], {});